var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDeskAlt1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1 3.77143C1 3.34538 1.3436 3 1.76744 3H22.2326C22.6564 3 23 3.34538 23 3.77143C23 4.19748 22.6564 4.54286 22.2326 4.54286H21.9767V20.2286C21.9767 20.6546 21.6331 21 21.2093 21C20.7855 21 20.4419 20.6546 20.4419 20.2286V15.0857H17.8837V17.1429C17.8837 17.5689 17.5401 17.9143 17.1163 17.9143C16.6924 17.9143 16.3488 17.5689 16.3488 17.1429V15.0857H14.0465C13.4814 15.0857 13.0233 14.6252 13.0233 14.0571V8.91429H7.65116V17.1429C7.65116 17.5689 7.30757 17.9143 6.88372 17.9143C6.45987 17.9143 6.11628 17.5689 6.11628 17.1429V8.91429H3.55814V20.2286C3.55814 20.6546 3.21454 21 2.7907 21C2.36685 21 2.02326 20.6546 2.02326 20.2286V4.54286H1.76744C1.3436 4.54286 1 4.19748 1 3.77143ZM15.75 10.5C15.75 10.0858 15.4142 9.75 15 9.75C14.5858 9.75 14.25 10.0858 14.25 10.5V12.5C14.25 12.9142 14.5858 13.25 15 13.25C15.4142 13.25 15.75 12.9142 15.75 12.5V10.5Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeskAlt1);
export default __webpack_public_path__ + "static/media/desk-alt-1.69e4cf04397bd1e257515b2504bc9f24.svg";
export { ForwardRef as ReactComponent };